export const isMe = id => id === '4517239960' // 1, hashed

export const priorityMap = {
  low: 1000,
  medium: 2000,
  high: 3000,
  urgent: 4000,
}
